type EmptyStateProps = {
  icon: string;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
};

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-16 text-center">
      <div className="mb-4 text-5xl" aria-hidden>
        {icon}
      </div>
      <h3 className="mb-2 text-lg font-semibold text-slate-900">{title}</h3>
      {description ? (
        <p className="mb-6 max-w-sm text-slate-500">{description}</p>
      ) : null}
      {action ? (
        <button
          type="button"
          onClick={action.onClick}
          className="rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#164477]"
        >
          {action.label}
        </button>
      ) : null}
    </div>
  );
}
